import { render, staticRenderFns } from "./SupportBoxSelectModal.vue?vue&type=template&id=a00b24b6&scoped=true&lang=pug&"
import script from "./SupportBoxSelectModal.vue?vue&type=script&lang=js&"
export * from "./SupportBoxSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./SupportBoxSelectModal.vue?vue&type=style&index=0&id=a00b24b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00b24b6",
  null
  
)

export default component.exports